import {TopBannerDefaultBox} from "./top-banner.default.box";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {TopBanner777Box} from "./top-banner.777.box";
import {TopBannerSIBox} from "./top-banner.si.box";

export const TopBannerBox = styledByTheme(TopBannerDefaultBox)
                            .forCasino777(TopBanner777Box)
                            .forSI(TopBannerSIBox)
                            .apply();